export default __webpack_public_path__ + "static/media/COMMUNICATION_TECHNOLOGY.4110b78c.png";